export const escapeRegex = (text: string) =>
    text.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
